/* tslint:disable */
/* eslint-disable */
/**
 * Berichtsmanagement Generator
 * Generator für AORV-Angebote
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContractParameters } from './ContractParameters';
import {
    ContractParametersFromJSON,
    ContractParametersFromJSONTyped,
    ContractParametersToJSON,
} from './ContractParameters';
import type { ReportType } from './ReportType';
import {
    ReportTypeFromJSON,
    ReportTypeFromJSONTyped,
    ReportTypeToJSON,
} from './ReportType';

/**
 * 
 * @export
 * @interface Contract
 */
export interface Contract {
    /**
     * 
     * @type {number}
     * @memberof Contract
     */
    id: number;
    /**
     * 
     * @type {ReportType}
     * @memberof Contract
     */
    type: ReportType;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    validFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    validTo?: string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    application: string;
    /**
     * 
     * @type {boolean}
     * @memberof Contract
     */
    immediateApproval: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Contract
     */
    includeOebbInfrastructure: boolean;
    /**
     * 
     * @type {ContractParameters}
     * @memberof Contract
     */
    parameters?: ContractParameters;
}

/**
 * Check if a given object implements the Contract interface.
 */
export function instanceOfContract(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "application" in value;
    isInstance = isInstance && "immediateApproval" in value;
    isInstance = isInstance && "includeOebbInfrastructure" in value;

    return isInstance;
}

export function ContractFromJSON(json: any): Contract {
    return ContractFromJSONTyped(json, false);
}

export function ContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): Contract {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ReportTypeFromJSON(json['type']),
        'name': json['name'],
        'kind': !exists(json, 'kind') ? undefined : json['kind'],
        'validFrom': !exists(json, 'validFrom') ? undefined : json['validFrom'],
        'validTo': !exists(json, 'validTo') ? undefined : json['validTo'],
        'application': json['application'],
        'immediateApproval': json['immediateApproval'],
        'includeOebbInfrastructure': json['includeOebbInfrastructure'],
        'parameters': !exists(json, 'parameters') ? undefined : ContractParametersFromJSON(json['parameters']),
    };
}

export function ContractToJSON(value?: Contract | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ReportTypeToJSON(value.type),
        'name': value.name,
        'kind': value.kind,
        'validFrom': value.validFrom,
        'validTo': value.validTo,
        'application': value.application,
        'immediateApproval': value.immediateApproval,
        'includeOebbInfrastructure': value.includeOebbInfrastructure,
        'parameters': ContractParametersToJSON(value.parameters),
    };
}

